export default __webpack_public_path__ + "static/media/moderate.a16c5498.png";